interface NutritionItem {
  label: string;
  value: string;
  unit: string;
}

interface NutritionCardProps {
  nutrition: NutritionItem[];
}

export default function NutritionCard({ nutrition }: NutritionCardProps) {
  return (
    <div className="bg-primary-50 rounded-2xl p-6">
      <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
        <i className="ri-bar-chart-2-line text-primary-500"></i>
        Nutrition Facts
      </h3>
      <div className="grid grid-cols-3 gap-4">
        {nutrition.map((item) => (
          <div key={item.label} className="text-center bg-white rounded-xl p-3 shadow-sm">
            <p className="text-xl font-bold text-primary-500">
              {item.value}
              <span className="text-xs font-normal text-gray-500 ml-0.5">{item.unit}</span>
            </p>
            <p className="text-xs text-gray-500 mt-1">{item.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
